import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";
import { Tag } from "primereact/tag";

const MemberDetailExtraComponent = ({ member }) => {
  return (
    <MeaDetailCard>

      <MeaDetailField field="Identifiant" value={member?.id || "-"} />
      <MeaDetailField field="Email" value={member?.email || "-"} />
      <MeaDetailField
        field="Connexion à l'école"
        value={
          member?.account_id ? <Tag severity="success" value="Oui" rounded /> : <Tag severity="danger" value="Non" rounded />
        }
      />
      <MeaDetailField field="Téléphone" value={member?.phone || "-"} />
      <MeaDetailField field="Adresse" value={(member?.address + "\n" + member?.postal_code + " " + member?.city) || "-"} />

    </MeaDetailCard>
  );
};

export default MemberDetailExtraComponent;
